class FoxkitFlashSale {
  constructor() {
    ;(this.selectors = {
      productsContainer: '#CollectionProductGrid',
      products: ['.m-product-card'],
      flashSale: '.foxkit-flashsale',
    }),
      (this.domNodes = queryDomNodes(this.selectors))
    const s = this.domNodes.productsContainer && this.domNodes.productsContainer.dataset.collectionId
    s && this.initFlashSale(s)
  }
  async initFlashSale(s) {
    const t = await fetchCountDown(s)
    if (t.ok && t.payload) {
      ;(this.settings = t.payload[0]), this.initCountdown()
      const { expires_date: s } = this.settings
      ;(this.expires_date = s),
        new Date(s).getTime() < Date.now() &&
          this.domNodes.flashSale &&
          this.domNodes.flashSale.classList.add('m:hidden'),
        this.domNodes.flashSale && this.domNodes.flashSale.classList.remove('m:hidden')
      this.domNodes.productsContainer.querySelectorAll(this.selectors.products).forEach((s) => {
        if (s.querySelector('.m-product-sale-progress')) return
        const t = s.querySelector('.m-product-card__content'),
          e = s.dataset.soldNumber,
          o = saleProgress(this.settings, s.dataset.productId, e),
          d = generateDomFromString(o)
        t.appendChild(d)
      })
    }
  }
  initCountdown() {
    this.domNodes.flashSale && this.domNodes.flashSale.classList.add(this.settings && this.settings.cdt_style),
      (this.Countdown = new MinimogTheme.FoxkitFlashSaleCountdown(this.settings)),
      this.Countdown &&
        this.Countdown.ended &&
        this.domNodes.flashSale &&
        this.domNodes.flashSale.classList.add('m:hidden')
  }
}
new FoxkitFlashSale()
